/**
 * Enum for application modules/resources used for permission checks.
 */
export enum ResourceModule {
  RESELLERS = 'qvara_admin.resellers',
  COUNTRIES = 'qvara_admin.countries',
  CUSTOMER_SIP_SERVERS = 'qvara_admin.customer_sip_servers',
  CARRIER_SIP_SERVERS = 'qvara_admin.carrier_sip_servers',
  JOB_QUEUES = 'qvara_admin.job_queues',
  HOLIDAYS = 'qvara_admin.holidays',
  PROVISIONING = 'qvara_admin.provisioning',
  ENTERPRISES = 'system.enterprises',
  ACCOUNTS = 'system.accounts',
  INTEGRATIONS = 'system.integrations',
  IPS_AND_PORTS = 'system.ips_and_ports',
  USERS = 'system.users',
  ROLES = 'qvara_admin.roles',
  MUSIC_ON_HOLD = 'uc_admin.settings_and_security.music_on_hold',
  CAPTCHAS = 'uc_admin.settings_and_security.captchas',
  BLOCKED_NUMBERS = 'uc_admin.settings_and_security.blocked_numbers',
  WEBHOOKS = 'uc_admin.settings_and_security.webhooks',
  RECORDINGS = 'uc_admin.settings_and_security.recordings',
  TWO_WAY_TOGGLES = 'uc_admin.call_flow.two_way_toggles',
  MULTIWAY_TOGGLES = 'uc_admin.call_flow.multiway_toggles',
  API_ROUTERS = 'uc_admin.call_flow.api_routers',
  TAG_ROUTERS = 'uc_admin.call_flow.tag_routers',
  CALL_QUEUES = 'uc_admin.call_flow.call_queues',
  STAR_CODES = 'uc_admin.settings_and_security.star_codes',
  RING_GROUPS = 'uc_admin.call_flow.ring_groups',
  SCHEDULES = 'uc_admin.call_flow.schedules',
  IVR_MENUS = 'uc_admin.call_flow.ivr_menus',
  VIP_CALLERS = 'uc_admin.call_flow.vip_callers',
  EXTENSIONS = 'uc_admin.extensions_and_devices.extensions',
  PHONEBOOKS = 'uc_admin.extensions_and_devices.phonebooks',
  PROVISIONING_DEVICES = 'uc_admin.extensions_and_devices.provisioning_devices',
  PHONE_NUMBERS = 'phone_numbers.manage',
  UC_PHONE_NUMBERS = 'uc_admin.phone_numbers',
  AUTOMATIONS = 'uc_admin.call_control_apps.automations',
  CALL_PARKING_LOTS = 'uc_admin.call_control_apps.call_parking_lots',
  CONFERENCE_BRIDGES = 'uc_admin.call_control_apps.conference_bridges',
  DIRECTORIES = 'uc_admin.call_control_apps.directories',
  FORWARDERS = 'uc_admin.call_control_apps.forwarders',
  PAGE_GROUPS = 'uc_admin.call_control_apps.page_groups',
  WAKEUP_CALLS = 'uc_admin.call_control_apps.wakeup_calls',
  UC_USER_AUTOMATIONS = 'uc_user.automations',
  UC_USER_BLOCKED_NUMBERS = 'uc_user.blocked_numbers',
  UC_USER_PHONEBOOKS = 'uc_user.phonebooks',
  UC_USER_CALL_FLOW_SETTINGS = 'uc_user.call_flow_settings',
  UC_USER_EXTENSION_SETTINGS = 'uc_user.extension_settings',
  UC_USER_VOICEMAILS = 'uc_user.voicemails',
  UC_USER_FAXING = 'uc_user.digital_faxing',
  UC_USER_MESSAGING = 'uc_user.sms/mms_messaging',
  REPORTS_ADMINISTRATIVE_AUTOMATIONS = 'reports.administrative.automations',
  REPORTS_VOICE_CALL_HISTORY = 'reports.voice.call_history',
  REPORTS_VOICE_IVR_ANALYSIS = 'reports.voice.ivr_analysis',
  REPORTS_VOICE_MISSED_CALLS = 'reports.voice.missed_calls',
  REPORTS_VOICE_EXTENSION_ANALYSIS = 'reports.voice.extension_analysis',
  REPORTS_VOICE_INBOUND_ANALYSIS = 'reports.voice.inbound_analysis',
  REPORTS_VOICE_CALL_QUEUE_ANALYSIS = 'reports.voice.call_queue_analysis',
  REPORTS_EMAIL_LOGS = 'reports.email_logs',
  REPORTS_MESSAGE_LOGS = 'reports.message_logs'
}

/**
 * Enum for standard CRUD operations/actions.
 */
export enum ResourceAction {
  VIEW = 'view',
  CREATE = 'create',
  EDIT = 'update',
  DELETE = 'delete',
  RESTORE = 'restore'
}

/**
 * Application-wide user role type codes.
 */
export const USER_ROLE_TYPES = {
  QVARA: 'qv',
  RESELLER: 'rs',
  ACCOUNT: 'ac',
  BASIC_USER: 'bu'
} as const

/**
 * Application-wide system user role slugs (`role_enum`).
 */
export const USER_ROLES = {
  QVARA_SUPER: 'qvara-super',
  QVARA_TECH: 'qvara-tech',
  RESELLER_ADMIN: 'reseller-admin',
  RESELLER_TECH: 'reseller-tech',
  ACCOUNT_ADMIN: 'account-admin',
  BASIC_USER: 'basic-user'
} as const

export const QVARA_ROLE_ENUMS: readonly string[] = [USER_ROLES.QVARA_SUPER, USER_ROLES.QVARA_TECH]

export const RESELLER_ROLE_ENUMS: readonly string[] = [
  USER_ROLES.RESELLER_ADMIN,
  USER_ROLES.RESELLER_TECH
]
